import React, { useContext, useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { styled } from "@material-ui/styles";
//
import {
  getPeriodStart,
  getPeriodEnd,
  snaTimePeriodOptions,
  getStartEndDate,
  getDefaultStartEndDate,
} from "../../../config/config.sna";
import { StoreContext } from "../../../store/StoreProvider";
import Act from "../../../store/actions";

const basicInputPropsDark = {
  "& fieldset": {
    borderColor: "#121212",
  },
  "&:hover fieldset": {
    // borderColor: "#121212",
  },
  "&.Mui-error fieldset": {
    borderColor: "#121212",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#121212",
  },
};

const basicRootProps = {
  minWidth: "90px",
  borderRadius: "4px",
};

const basicInputProps = {
  marginRight: "8px",
  fontSize: "14px",
};

// basic style
const StyledTextField = styled(TextField)(({ theme }) => ({
  ...basicRootProps,
  color: "#fff",
  // backgroundColor: "#121212",
  "&.MuiTextField-root": {
    maxWidth: "167px",
    "& label": {
      color: "#fff",
    },
    "& .MuiOutlinedInput-root": {
      ...basicInputProps,
      color: "#ffffff",
      backgroundColor: "#121212",
      ...basicInputPropsDark,
      "& Fieldset": {
        border: "1px solid #505050",
      },
    },
    "& .MuiSvgIcon-root": {
      width: "20px",
      color: "#fff",
      backgroundColor: "#121212",
    },
  },
}));

const MyDatePicker = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { timePeriod, startEndDate } = sna.filter;
  const [value, setValue] = useState({
    startDate: startEndDate.change[0] || getDefaultStartEndDate()[0],
    endDate: startEndDate.change[1] || getDefaultStartEndDate()[1],
  });

  // handle search input change
  const handleSearchChange = (key) => (data) => {
    if (key in value && data) {
      setValue((prev) => ({
        ...prev,
        [key]: data,
      }));
      dispatch({
        type: Act.SNA_FILTER_TIME_PERIOD_CHANGE,
        payload: "",
      });
    }
  };

  useEffect(() => {
    const curPeriod = snaTimePeriodOptions.find(
      (po) => po.value === timePeriod.change
    );
    if (!curPeriod) {
      return;
    }
    const dateArray = getStartEndDate(curPeriod);
    setValue({
      startDate: dateArray[0],
      endDate: dateArray[1],
    });
  }, [timePeriod]);

  useEffect(() => {
    if (value) {
      dispatch({
        type: Act.SNA_FILTER_START_END_DATE_CHANGE,
        payload: Object.assign([], [value.startDate, value.endDate]),
      });
    }
  }, [value]);

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <Stack component="form" noValidate spacing={3}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Start date"
          value={value.startDate}
          views={["year", "month", "day"]}
          minDate={getPeriodStart()}
          maxDate={getPeriodEnd()}
          onChange={handleSearchChange("startDate")}
          renderInput={(params) => <StyledTextField {...params} />}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="End date"
          value={value.endDate}
          views={["year", "month", "day"]}
          minDate={getPeriodStart()}
          maxDate={getPeriodEnd()}
          onChange={handleSearchChange("endDate")}
          renderInput={(params) => <StyledTextField {...params} />}
        />
      </LocalizationProvider>
    </Stack>
  );
};

export default MyDatePicker;
